__turbopack_context__.v({
  "CheckboxField": "NakXJq_CheckboxField",
  "CheckboxLabel": "NakXJq_CheckboxLabel",
  "ColorOption": "NakXJq_ColorOption",
  "ColorPickerWrapper": "NakXJq_ColorPickerWrapper",
  "ErrorText": "NakXJq_ErrorText",
  "Field": "NakXJq_Field",
  "Fields": "NakXJq_Fields",
  "GroupTitle": "NakXJq_GroupTitle",
  "Input": "NakXJq_Input",
  "Invalid": "NakXJq_Invalid",
  "Label": "NakXJq_Label",
  "OptionsGroup": "NakXJq_OptionsGroup",
  "RadioLabel": "NakXJq_RadioLabel",
  "Select": "NakXJq_Select",
  "skeleton-loading": "NakXJq_skeleton-loading",
});
